import { routeGroups } from './route-catalog';
export type { MenuAudience, MenuPage, MenuGroup } from './route-catalog';
import type { MenuAudience, MenuGroup } from './route-catalog';
export const navigationGroups = (audience: MenuAudience): MenuGroup[] => routeGroups(audience);
export function searchMenu(groups: MenuGroup[], query: string): MenuGroup[] {
  const term = query.trim().toLocaleLowerCase();
  return groups
    .map((g) => ({
      ...g,
      pages: g.pages.filter((p) =>
        `${g.label} ${g.terms} ${p.label} ${p.terms}`.toLocaleLowerCase().includes(term),
      ),
    }))
    .filter((g) => g.pages.length > 0);
}
export function permittedPins(value: unknown, audience: MenuAudience): string[] {
  const permitted = new Set(navigationGroups(audience).flatMap((g) => g.pages.map((p) => p.key)));
  return Array.isArray(value)
    ? [
        ...new Set(
          value.filter((key): key is string => typeof key === 'string' && permitted.has(key)),
        ),
      ].slice(0, 3)
    : [];
}
export function loadPins(audience: MenuAudience): string[] {
  try {
    return permittedPins(
      JSON.parse(localStorage.getItem(`sqi-oem-menu-pins-${audience}`) ?? '[]'),
      audience,
    );
  } catch {
    return [];
  }
}
export function savePins(audience: MenuAudience, pins: string[]): void {
  try {
    localStorage.setItem(
      `sqi-oem-menu-pins-${audience}`,
      JSON.stringify(permittedPins(pins, audience)),
    );
  } catch {
    /* Menu stays usable when browser storage is unavailable. */
  }
}
